import { isResellerPoint } from '@/utils/hopPuntos';

const hasSellingCapability = (point) => isResellerPoint(point);

const filterPointsByService = (points, service) => {
  if (service === 'buy') {
    return {
      pickup: (points?.pickup || []).filter(hasSellingCapability),
      dropOff: (points?.dropOff || []).filter(hasSellingCapability)
    };
  }

  return {
    pickup: service === 'dropoff' ? [] : points?.pickup || [],
    dropOff: service === 'pickup' ? [] : points?.dropOff || []
  };
};

module.exports = { filterPointsByService };